import './App.scss';
import Router from './Router/Router';
import 'antd/dist/antd.min.css';
import { QueryClient, QueryClientProvider } from 'react-query';
import fetchIntercept from 'fetch-intercept';
import { getTokenExpire } from './utils/utilFunctions';
import { setRedirectPath } from './utils/redirectAfterLogin';
import { StatusCodes } from 'http-status-codes';

function redirectToLogin() {
  const path = typeof window !== 'undefined' ? window.location.pathname + window.location.search : '';
  if (path && path !== '/' && path !== '/autentificare') {
    setRedirectPath(path);
  }
  window.location.href = '/autentificare?expired=true';
}

fetchIntercept.register({
  response: (response) => {
    const expire = getTokenExpire();
    const now = Date.now() / 1000;

    if (response.request?.headers && response.request.headers.has('authorization') &&
      response.status === StatusCodes.UNAUTHORIZED && (!expire || expire < now)) {
      localStorage.removeItem("token");
      redirectToLogin();
    }

    return response;
  },
  responseError: (error) => {
    const expire = getTokenExpire();
    const now = Date.now() / 1000;

    if (error.request?.headers && error.request.headers.has('authorization') && (!expire || expire < now)) {
      localStorage.removeItem("token");
      redirectToLogin();
    }

    return Promise.reject(error);
  }
});

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <div className='App'>
        <Router />
      </div>
    </QueryClientProvider>
  );
}

export default App;
